const $ = jQuery.noConflict();

'use strict';
const DropdownToggle = {
	/**
	 * @description Cache DOM elements and strings
	 * @type {object}
	 */
	$domToggleButton: $('.js-dropdown-toggle-init'),
	$domDropdownMenu: $('.js-dropdown-toggle-menu'),
	$dropdownItems: $('.js-dropdown-item'), // Dodato: Selektor za dropdown stavke
	classActive: 'is-active',
	menuDuration: 300, // Duration for slide animation in ms

	/** @description Initialize the dropdown functionality */
	init: function() {
		this.bindEvents(); // Bind all necessary event listeners
	},

	/** @description Bind event listeners */
	bindEvents: function() {
		// Toggle dropdown menu on button click
		this.$domToggleButton.on('click', this.toggleDropdown.bind(this));

		// Handle selection of dropdown items
		this.$dropdownItems.on('click', this.selectDropdownItem.bind(this));

		// Close dropdown when clicking outside
		$(document).on('click', this.handleOutsideClick.bind(this));
	},

	/**
	 * @description Toggle the dropdown menu
	 * @param {Event} e - The click event
	 */
	toggleDropdown: function(e) {
		e.preventDefault();

		// Toggle visibility of the dropdown menu
		this.$domDropdownMenu.slideToggle(this.menuDuration);

		// Add or remove the active class on the toggle button
		this.$domToggleButton.toggleClass(this.classActive);
	},

	/**
	 * @description Handle selection of a dropdown item
	 * @param {Event} e - The click event
	 */
	selectDropdownItem: function(e) {
		const $selectedItem = $(e.target).closest('.js-cat-dropdown'); // Get the clicked item

		// Remove 'is-active' class from all dropdown items
		this.$dropdownItems.removeClass(this.classActive);

		// Add 'is-active' class to the selected item
		$selectedItem.addClass(this.classActive);

		// Update the dropdown toggle button text with the selected item's text
		const selectedText = $selectedItem.find('.dropdown__link').text();
		this.$domToggleButton.find('.js-dropdown-name').text(selectedText);

		// Close the dropdown menu
		this.$domDropdownMenu.slideUp(this.menuDuration);
		this.$domToggleButton.removeClass(this.classActive);
	},

	/**
	 * @description Close the dropdown if a click occurs outside of it
	 * @param {Event} e - The click event
	 */
	handleOutsideClick: function(e) {
		// Check if the click is outside the dropdown menu or toggle button
		const isOutside = !$(e.target).closest(this.$domDropdownMenu).length && !$(e.target).closest(this.$domToggleButton).length;

		if (isOutside) {
			// Close the dropdown menu
			this.$domDropdownMenu.slideUp(this.menuDuration);

			// Remove the active class from the toggle button
			this.$domToggleButton.removeClass(this.classActive);
		}
	},
};

export default DropdownToggle;